import { apiFetch } from '$lib/api/helpers';
import type { SceneRequest, SceneResponse } from '$lib/types/scene';

const PATH = '/scenes/';

export async function fetchScenes() {
	return apiFetch<Array<SceneResponse>>(PATH);
}

export async function fetchSceneById(id: number) {
	return apiFetch<SceneResponse>(`${PATH}${id}/`);
}

export async function createScene(sceneRequest: SceneRequest) {
	return apiFetch<SceneResponse>(PATH, {
		method: 'POST',
		body: JSON.stringify(sceneRequest)
	});
}

export async function updateScene(id: number, sceneRequest: Partial<SceneRequest>) {
	return apiFetch<SceneResponse>(`${PATH}${id}/`, {
		method: 'PATCH',
		body: JSON.stringify(sceneRequest)
	});
}

export async function deleteScene(id: number) {
	return apiFetch<void>(`${PATH}${id}/`, { method: 'DELETE' });
}

export async function cloneScene(id: number) {
	return apiFetch<SceneResponse>(`${PATH}${id}/clone/`, { method: 'POST' });
}
